<script setup lang="ts">
import type { LinkNode } from '@laam/cms-shared';
interface BrandCardProps {
	entityData: LinkNode;
	horizontalIndex?: number;
	variant: 'carousel' | 'list';
	carousel?: string;
}
const props = withDefaults(defineProps<BrandCardProps>(), {
	variant: 'carousel',
	horizontalIndex: undefined,
	carousel: '',
});
const isCarousel = computed(() => props.variant === 'carousel');
const handleClick = inject('handleClick') as (
	brandName: string,
	brandHandle: string,
	image: string,
	verticalIndex: number,
	productCount: number,
	carousel: string,
) => void;
</script>
<template>
	<div>
		<NuxtLink
			v-if="isCarousel"
			class="flex flex-col gap-md items-center hover:cursor-pointer"
			:to="`${entityData.href}`"
			@click="
				handleClick(
					entityData.name,
					entityData.href,
					entityData.logo ?? '',
					horizontalIndex ?? 0,
					entityData.product_count ?? 0,
					isCarousel ? carousel : '',
				)
			"
		>
			<div
				class="border border-gray-200 bg-white lg:size-[115px] rounded-7xl size-[80px] flex items-center"
				:class="{
					' p-md': !entityData.logo,
				}"
			>
				<NuxtImg
					v-if="!!entityData.logo"
					:src="entityData.logo"
					class="p-xs flex flex-1 rounded-[22px]"
				/>
				<div
					v-else
					class="bg-gray-200 rounded-5xl w-full h-full flex items-center justify-center text-center text-sm font-bold lg:text-lg lg:font-semibold"
				>
					{{ entityData.name?.charAt(0).toUpperCase() }}
				</div>
			</div>
			<div
				class="whitespace-normal lg:w-[115px] w-[80px] break-words text-gray-700 text-center text-xs lg:text-sm font-medium"
			>
				{{ entityData.name }}
			</div>
		</NuxtLink>
		<div v-else class="overflow-hidden">
			<div
				class="border border-gray-200 bg-white h-[48px] w-[48px] rounded-xl flex items-center"
				:class="{
					' p-md': !entityData.logo,
				}"
			>
				<NuxtImg
					v-if="!!entityData.logo"
					:src="entityData.logo"
					class="p-xs flex rounded-[10px]"
				/>
				<div
					v-else
					class="bg-gray-200 text-center text-sm font-bold lg:text-lg lg:font-semibold rounded-[10px]"
				>
					{{ entityData.name?.charAt(0).toUpperCase() }}
				</div>
			</div>
		</div>
	</div>
</template>
